export default __webpack_public_path__ + "static/media/logo.2904f35b.svg";